import { Module } from 'vuex';
import { RootState } from '../types'
import { examState } from "./exam"
import { headerState } from "./header"
import { footerState } from "./footer"
import { userState } from "./user"
import { menuState } from "./menu"
import { notificationState } from "./notification"
import { subscriptionState } from "./subscription"
import { userQuestionState } from "./user_quetions"
import { coursePurchaseState } from "./course_purchase"
import { examTestState } from './exam_test';
import { examResultState } from './exam_result';
import { snackBarState } from './snackbar';

export const store: Module<RootState, RootState> = {
  namespaced: true,
  modules: {}
}

export const dataStore = {
  userQuestionState,
  userState,
  subscriptionState,
  notificationState,
  examState,
  examTestState,
  headerState,
  footerState,
  snackBarState,
  menuState,
  examResultState,
  coursePurchaseState,
}
